import React from 'react';
import Input from '../../../components/ui/Input';
import { cn } from '../../../utils/cn';

const UserBasicInfoSection = ({
  formData,
  errors,
  onFieldChange,
  isEditMode
}) => {
  return (
    <div className="bg-white rounded-lg border border-border shadow-sm p-6">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-foreground mb-2">
          Informações básicas
        </h2>
        <p className="text-sm text-muted-foreground">
          Forneça os dados essenciais para a conta do usuário
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Full Name */}
        <div>
          <label htmlFor="fullName" className="block text-sm font-medium text-foreground mb-2">
            Nome completo <span className="text-red-500">*</span>
          </label>
          <Input
            id="fullName"
            type="text"
            placeholder="Digite o nome completo"
            value={formData?.fullName || ''}
            onChange={(e) => onFieldChange?.('fullName', e?.target?.value)}
            className={cn(
              errors?.fullName && 'border-red-300 focus:border-red-500 focus:ring-red-200'
            )}
            autoComplete="name"
          />
          {errors?.fullName && (
            <p className="mt-1 text-xs text-red-600">
              {errors?.fullName}
            </p>
          )}
        </div>

        {/* Email Address */}
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-foreground mb-2">
            Endereço de e-mail <span className="text-red-500">*</span>
          </label>
          <Input
            id="email"
            type="email"
            placeholder="Digite o e-mail"
            value={formData?.email || ''}
            onChange={(e) => onFieldChange?.('email', e?.target?.value)}
            className={cn(
              errors?.email && 'border-red-300 focus:border-red-500 focus:ring-red-200'
            )}
            autoComplete="email"
          />
          {errors?.email && (
            <p className="mt-1 text-xs text-red-600">
              {errors?.email}
            </p>
          )}
          {!errors?.email && (
            <p className="mt-1 text-xs text-muted-foreground">
              {isEditMode 
                ? 'Alterar o e-mail exigirá verificação do usuário'
                : 'O usuário receberá as credenciais de acesso neste e-mail'
              }
            </p>
          )}
        </div>
      </div>
      {/* Email Uniqueness Info */}
      <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-3">
        <div className="flex items-start space-x-2">
          <svg className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div className="text-sm text-blue-800">
            <p className="font-medium mb-1">Validação de e-mail</p>
            <p className="text-xs">
              Verificaremos automaticamente se este e-mail já está em uso por outro usuário no sistema.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserBasicInfoSection;